import React from 'react';
import { Link } from 'react-router-dom';
/*import { useDarkMode } from '../contexts/DarkModeContext';*/
import logo from '../assets/images/navbar/logo.png';
import about from '../assets/images/navbar/about.png';
import works from '../assets/images/navbar/works.png';
//import sun from '../assets/images/navbar/sun.png';
//import moon from '../assets/images/navbar/moon.png';
import fade1 from '../assets/images/navbar/fade-1.png';
import fade2 from '../assets/images/navbar/fade-2.png';

const imgHeight = '40px';

const Header: React.FC = () => {
    /*const { isDarkMode, toggleDarkMode } = useDarkMode();*/

    return (
        <nav
            className="navbar navbar-expand custom-navbar"
        >
            {/* Background Images */}
            <img
                src={fade1}
                alt="Navbar fade left"
                className="navbar-bg fade-left"
            />
            <img
                src={fade2}
                alt="Navbar fade right"
                className="navbar-bg fade-right"
            />

            <div className="container-fluid">
                {/* Logo */}
                <Link className="navbar-brand" to="/">
                    <img
                        src={logo}
                        alt="SecretAria Logo"
                        style={{ maxWidth: 'auto', height: imgHeight }}
                    />
                </Link>

                {/* Offcanvas Trigger Button */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasNavbar"
                    aria-controls="offcanvasNavbar"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Offcanvas Menu */}
                <div
                    className="offcanvas offcanvas-end"
                    tabIndex={-1}
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                >
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="offcanvasNavbarLabel">Menu</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="offcanvas-body">
                        <ul className="navbar-nav ms-auto">
                            {/* About Link */}
                            <li className="nav-item mx-1">
                                <Link className="nav-link" to="/about">
                                    <img
                                        src={about}
                                        alt="About"
                                        style={{ maxWidth: 'auto', height: imgHeight }}
                                    />
                                </Link>
                            </li>

                            {/* Works Link */}
                            <li className="nav-item mx-1">
                                <Link className="nav-link" to="/works">
                                    <img
                                        src={works}
                                        alt="Works"
                                        style={{ maxWidth: 'auto', height: imgHeight }}
                                    />
                                </Link>
                            </li>

                            {/* Dark Mode Toggle */}
                            {/*<li className="nav-item mx-1">*/}
                            {/*    <button*/}
                            {/*        type="button"*/}
                            {/*        className="btn"*/}
                            {/*        onClick={toggleDarkMode}*/}
                            {/*        style={{ padding: 0, border: 'none', background: 'none' }}*/}
                            {/*    >*/}
                            {/*        <img*/}
                            {/*            src={isDarkMode ? sun : moon}*/}
                            {/*            alt={isDarkMode ? 'Light Mode' : 'Dark Mode'}*/}
                            {/*            style={{ maxWidth: 'auto', height: imgHeight }}*/}
                            {/*        />*/}
                            {/*    </button>*/}
                            {/*</li>*/}
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Header;
